import { getStore } from 'core_main/store';
import { InitializePubNubParameters } from 'core_main/pubnub/types';

export const importAndInitializePubNub = (
  params?: InitializePubNubParameters,
) => {
  return import(/* webpackChunkName: "pubnub" */ '../pubnub').then((pubnub) => {
    if (!params) return pubnub;

    const { customerId, orgId, channels, initCallback } = params;
    const store = getStore();

    if (!store.isPubNubConnected) {
      return pubnub.initializePubNub({
        customerId,
        orgId,
        initCallback,
        channels,
      });
    }

    if (channels) {
      pubnub.subscribe({ channels });
    }

    return pubnub;
  });
};
